import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as config from "../../constants/config";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as orderStatus from "../../constants/orderStatus";
import * as resultCodes from "../../constants/resultCodes";
import * as rcc from "../../constants/rcc";
import * as settings from "../../constants/settings";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.ADD_ORDER_RECORD:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let orderActions = [
                messageHelper.getSuccessMessageAction("flashMessage.orderCreated"),
                {
                    type: actionTypes.MENU_ADD_NEW_OR_RESET_MAIN_TAB,
                    payload: {
                        scene: componentTypes.DATABASE_SCENE
                    }
                }
            ];

            if (state.intergammaOrder.customer !== null || state.intergammaOrder.lastCustomer !== null) {
                orderActions.push({
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.INTERGAMMA_CONFIRM_CUSTOMER_MODAL,
                        params: {
                            customer: state.intergammaOrder.customer || state.intergammaOrder.lastCustomer
                        }
                    }
                });
            }

            return orderActions;
        case handlers.ADD_ORDER_RECORD_AND_CLOSE_MODAL:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let addOrderRequests = [
                messageHelper.getSuccessMessageAction("flashMessage.orderCreated"),
                {
                    type: actionTypes.NAVIGATION_CLOSE_ALL_MODALS
                }
            ];

            if (state.module.redlikeLightSoftware) {
                addOrderRequests.push(
                    {
                        type: actionTypes.CLOSE_ACTIVE_TAB,
                        payload: {
                            newActive: componentTypes.DEFAULT_TAB_ID,
                            newTabList: state.navigation.tabList.filter((tab) => tab.id !== tabId)
                        }
                    },
                    {
                        type: actionTypes.OPEN_HOME_TAB
                    }
                );
            }

            let myOrdersTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.MY_ORDERS_TAB);

            addOrderRequests.push({
                type: actionTypes.MY_ORDERS_LIST_UPDATE,
                payload: {
                    tabId: myOrdersTab === undefined ? 0 : myOrdersTab.id
                }
            });

            return addOrderRequests;
        case handlers.TO_DISPENSE_GET_ORDERS:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            let newOrderList = modelHelper.mapOrdersToObjects(response.data.orders);

            let validOrders = false;
            if (state.toDispense.activeOrder !== null) {
                validOrders = newOrderList.some((order) => order.id === state.toDispense.activeOrder.id);
            }

            let toDispenseRequest = [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_ORDERS,
                    payload: {
                        orders: newOrderList,
                        validOrder: validOrders
                    }
                }
            ];

            if (
                !validOrders &&
                state.module.redlikeLightSoftware &&
                state.navigation.activeTabScene === componentTypes.DETAIL_SCENE
            ) {
                toDispenseRequest.push({
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.TABLE_SCENE
                    }
                });
            }

            return toDispenseRequest;
        case handlers.TO_DISPENSE_GET_ORDERS_WITH_OFFSET:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_ORDERS_WITH_OFFSET,
                    payload: {
                        orders: modelHelper.mapOrdersToObjects(response.data.orders)
                    }
                }
            ];
        case handlers.TO_DISPENSE_GET_ORDERS_WITH_NOTIFICATION:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.TO_DISPENSE_PROCESS_NOTIFICATION_ORDERS,
                    payload: {
                        notificationOrders: modelHelper.mapOrdersToObjects(response.data.orders),
                        tabId: tabId
                    }
                }
            ];
        case handlers.TO_DISPENSE_GET_DETAIL:
            if (!responseHelper.isOrderDetailFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            response.data.order.shotsName = state.settings.shotsName;
            response.data.order.colorantPanelOrderBy = state.settings.colorantPanelOrderBy;

            if (response.data.order.brand === state.server.activeDatabase.name) {
                return [
                    {
                        type: actionTypes.TO_DISPENSE_SAVE_ORDER_DETAIL,
                        payload: {
                            tabId: tabId,
                            order: response.data.order,
                            printData: response.data.order.printData,
                            tmcData: response.data.order.tmcData,
                            infoData: response.data.order.infoData,
                            validation: modelHelper.mapFormulaValidationErrorsToObject(
                                [],
                                rcc.RCC_VALIDATION_OK,
                                state.settings.validateTotalCntAmounts,
                                state.settings.validateOverfill,
                                state.settings.validateMinDosableAmount,
                                state.settings.colorantBatchNumberLogic !==
                                    settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                                state.settings.validateColorantBaseRules,
                                state.settings.colorantBatchForMultipleCans
                            )
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_PLAIN_ORDER_DETAIL,
                    payload: {
                        tabId: tabId,
                        order: response.data.order,
                        database: state.server.activeDatabase.name,
                        tmcData: response.data.order.tmcData,
                        infoData: response.data.order.infoData,
                        printData: response.data.order.printData,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            rcc.RCC_VALIDATION_OK,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                }
            ];
        case handlers.TO_DISPENSE_DELETE_ORDER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let toDisTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.TO_DISPENSE_TAB);

            return [
                {
                    type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                    payload: {
                        tabId: toDisTab !== undefined ? toDisTab.id : 0
                    }
                }
            ];
        case handlers.TO_DISPENSE_SET_ORDER_STATUS_DONE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.TO_DISPENSE_RESET_ORDER
                },
                {
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.TABLE_SCENE
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_TO_DISPENSE_GET_ORDERS,
                        params: {
                            statusFilter: orderStatus.TO_DISPENSE_ORDER_STATUS_LIST,
                            orderBy: state.settings.intergammaMachineSortingOrders,
                            offset: 0,
                            rowCount: config.MAX_ORDERS_LIMIT
                        }
                    },
                    method: handlers.TO_DISPENSE_GET_ORDERS,
                    tabId: tabId
                }
            ];
        case handlers.SET_ORDER_MORE_INFO:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [];
        case handlers.ASSIGN_ORDER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [];
        case handlers.RELEASE_ORDER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [];
        case handlers.MY_ORDERS_GET_DATA:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }
            return [
                {
                    type: actionTypes.MY_ORDERS_SAVE_DATA,
                    payload: {
                        myOrderList: response.data.orders
                    }
                }
            ];
        case handlers.MY_ORDERS_GET_DATA_WITH_OFFSET:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }
            return [
                {
                    type: actionTypes.MY_ORDERS_SAVE_DATA_WITH_OFFSET,
                    payload: {
                        myOrderList: response.data.orders
                    }
                }
            ];
        case handlers.MY_ORDERS_GET_DETAIL:
            if (!responseHelper.isOrderDetailFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            response.data.order.shotsName = state.settings.shotsName;
            response.data.order.colorantPanelOrderBy = state.settings.colorantPanelOrderBy;

            return [
                {
                    type: actionTypes.MY_ORDERS_SAVE_DETAIL,
                    payload: {
                        tabId: tabId,
                        order: response.data.order,
                        printData: response.data.order.printData,
                        tmcData: response.data.order.tmcData,
                        infoData: response.data.order.infoData
                    }
                }
            ];
        case handlers.MY_ORDERS_GET_DETAIL_AND_OPEN_MODAL:
            if (!responseHelper.isOrderDetailFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            response.data.order.shotsName = state.settings.shotsName;
            response.data.order.colorantPanelOrderBy = state.settings.colorantPanelOrderBy;

            return [
                {
                    type: actionTypes.MY_ORDERS_SAVE_DETAIL,
                    payload: {
                        tabId: tabId,
                        order: response.data.order,
                        printData: response.data.order.printData,
                        tmcData: response.data.order.tmcData,
                        infoData: response.data.order.infoData
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.INTERGAMMA_LOAD_HISTORY_ORDER_MODAL
                    }
                }
            ];
        case handlers.ORDERS_HISTORY_GET_ORDERS:
            if (!responseHelper.isGetOrdersFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            let newOrders = modelHelper.mapOrdersToObjects(response.data.orders);

            let validOrder = false;
            if (state.ordersHistory.activeOrder !== null) {
                validOrder = newOrders.some((order) => order.id === state.ordersHistory.activeOrder.id);
            }

            return [
                {
                    type: actionTypes.ORDERS_HISTORY_SAVE_ORDERS,
                    payload: {
                        orders: newOrders,
                        validOrder: validOrder
                    }
                }
            ];
        case handlers.GET_ORDERS_HISTORY_WITH_OFFSET:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.ORDERS_HISTORY_SAVE_ORDER_LIST_WITH_OFFSET,
                    payload: {
                        orders: response.data.orders
                    }
                }
            ];
        case handlers.ORDERS_HISTORY_GET_DETAIL:
            if (!responseHelper.isOrderDetailFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            response.data.order.shotsName = state.settings.shotsName;
            response.data.order.colorantPanelOrderBy = state.settings.colorantPanelOrderBy;

            if (response.data.order.brand === state.server.activeDatabase.name) {
                return [
                    {
                        type: actionTypes.ORDERS_HISTORY_SAVE_ORDER_DETAIL,
                        payload: {
                            order: response.data.order,
                            printData: response.data.order.printData,
                            tmcData: response.data.order.tmcData,
                            infoData: response.data.order.infoData
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.ORDERS_HISTORY_SAVE_PLAIN_ORDER_DETAIL,
                    payload: {
                        order: response.data.order,
                        database: state.server.activeDatabase.name,
                        tmcData: response.data.order.tmcData,
                        infoData: response.data.order.infoData,
                        printData: response.data.order.printData
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
